import dayjs from "dayjs"

/**
 * The dates in the DB are UTC timestamps, without hours and minutes.
 * @param date
 * @returns {number|null}
 */
export function toMidnightTimestamp(date) {
  if (!date) return null
  return dayjs.utc(date).startOf("day").valueOf()
}

export function formatDateTime(date) {
  if (!date) return null
  return dayjs(date).format("YYYY-MM-DD HH:mm:ss")
}